import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FeaturesAndBenefitsComponent} from './features-and-benefits.component';
import {ConfigModule, I18nModule} from '@spartacus/core';

import {MediaModule} from '@spartacus/storefront';
import {YouTubePlayerModule} from '@angular/youtube-player';

@NgModule({
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ProductFeaturesAndBenefitsComponent: {
          component: FeaturesAndBenefitsComponent,
        },
      },
    }),
    I18nModule,
    MediaModule,
    YouTubePlayerModule,
    FeaturesAndBenefitsComponent,
  ],
  exports: [FeaturesAndBenefitsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class FeaturesAndBenefitsModule {}
